import React from "react";
import InputForm from "../InputForm/InputForm";
import DynamicInputForm from "../DynamicForm/DynamicInputForm";
import { AddCircleOutlineMaterialIcon } from "Icons/MaterialIcons";
import { v4 as uuidv4 } from "uuid";
import "./StepContentForm.scss";
import PopOverComponent from "components/UI/MaterialUIComponents/PopOverComponent";

const StepContentForm = ({
	textLabel,
	inputType,
	inputName,
	setInputField,
	inputFields,
	inputField,
	setValidate,
	placeholder,
	setError,
	spanClassName,
	spanError,
	dynamicInputs = false,
	addDynamicInput,
	infoText,
	classNameInput,
	checkToDisableInput,
	textToDisableInput,
	disableInput,
	setDisableInput,
}) => {
	const handleChangeCheckBox = (e) => setDisableInput(e.target.checked);

	return (
		<>
			<span className="labelInfoContainer">
				<PopOverComponent label={textLabel}>
					<span className="info-popover">{infoText}</span>
				</PopOverComponent>
			</span>
			{dynamicInputs ? (
				inputFields.map((i) => {
					return (
						<div key={i[0]} className="addOrEditForm__inputGroup">
							<DynamicInputForm
								inputType={inputType}
								inputName={inputName}
								setInputField={setInputField}
								inputFields={inputFields}
								placeholder={placeholder}
								inputField={i}
								disabled={disableInput}
								setValidate={setValidate}
								setError={setError}
							/>
						</div>
					);
				})
			) : (
				<InputForm
					inputType={inputType}
					inputName={inputName}
					setInputField={setInputField}
					placeholder={placeholder}
					inputField={inputField}
					setValidate={setValidate}
					setError={setError}
					classNameInput={classNameInput}
				/>
			)}
			<span className={spanClassName}>{spanError}</span>
			{dynamicInputs && (
				<span
					className="addOrEditForm__addLink"
					onClick={() => {
						setInputField([...inputFields, [uuidv4(), "", false]]);
					}}
				>
					<span className="addLink__span">{addDynamicInput}</span>
					<AddCircleOutlineMaterialIcon className="addOrEditForm__icon" />
				</span>
			)}
			{checkToDisableInput && (
				<label className="labelCheckbox">
					{textToDisableInput}
					<input
						type="checkbox"
						onChange={handleChangeCheckBox}
						checked={disableInput}
					/>
				</label>
			)}
		</>
	);
};

export default StepContentForm;
